import { FC, memo } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { PointsListCheckboxGroupPointType } from 'application/components/PointItemContent/types';
import { RouterUtils, useNavigate } from 'application/providers/RouterProvider';
import { POINTS_MENU_PATH } from 'application/consts';
import { useOnboardingActionContext } from 'application/components/common';
import { PlayerSupportedFeatures } from 'application/pages/constants';

import Text from '@zvuk-b2b/react-uikit/ui/Text';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import PointAddressesList from './PointAddressesList';
import { TEXTS } from '../../texts';

import styles from './index.module.scss';

export type VideoStreamBindSuccessModalProps = {
  selectedPoints: PointsListCheckboxGroupPointType[];
};

const VideoStreamBindSuccessModal: FC<ModalProps[ModalTypes.VIDEO_STREAM_BIND_SUCCESS]> = ({
  close,
  selectedPoints = [],
}) => {
  const { clearCurrentPoint } = useOnboardingActionContext();

  const navigate = useNavigate();

  const onBindPointSuccessClick = () => {
    navigate(RouterUtils.generatePath(POINTS_MENU_PATH));

    clearCurrentPoint();
    close();
  };

  const allDevicesOfPointsHasVideoSupport = selectedPoints.every(
    (point) => point.device && point.device.supportedFeatures.includes(PlayerSupportedFeatures.VideoSupport)
  );

  return (
    <ModalScreen
      title={
        allDevicesOfPointsHasVideoSupport
          ? TEXTS.MODAL_BIND_SUCCESS_TITLE
          : TEXTS.MODAL_BIND_WITHOUT_PLAYING_SUCCESS_TITLE
      }
      titlePlacement="left"
      containerClassName={styles.modalContainer}
      onClose={close}
      actionButtons={[
        <Button
          key="button_open_points_bind_success_modal"
          elementId="button_open_points_bind_success_modal"
          type={ButtonType.PRIMARY}
          onClick={onBindPointSuccessClick}>
          {TEXTS.MODAL_BIND_SUCCESS_TO_POINTS_TEXT}
        </Button>,

        <Button
          key="button_cancel_bind_success_modal"
          elementId="button_cancel_bind_success_modal"
          type={ButtonType.SECONDARY}
          onClick={() => close()}>
          {TEXTS.MODAL_BIND_SUCCESS_BUTTON_CANCEL_TEXT}
        </Button>,
      ]}>
      {selectedPoints.length > 0 ? (
        <div className={styles.addresses}>
          <Text elementId="modal_bind_success_selected_points_text">
            {allDevicesOfPointsHasVideoSupport
              ? TEXTS.MODAL_BIND_SUCCESS_SELECTED_POINTS_TEXT
              : TEXTS.MODAL_BIND_WITHOUT_PLAYING_SUCCESS_SELECTED_POINTS_TEXT}
          </Text>

          <PointAddressesList
            selectedPoints={selectedPoints}
            allDevicesOfPointsHasVideoSupport={allDevicesOfPointsHasVideoSupport}
          />
        </div>
      ) : (
        TEXTS.VIDEO_STREAM_INFO_NO_POINTS
      )}
    </ModalScreen>
  );
};

export default memo(VideoStreamBindSuccessModal);
